import { render, staticRenderFns } from "./GoodsSocksView.vue?vue&type=template&id=5ee053ee&"
import script from "./GoodsSocksView.vue?vue&type=script&lang=js&"
export * from "./GoodsSocksView.vue?vue&type=script&lang=js&"
import style0 from "./GoodsSocksView.vue?vue&type=style&index=0&id=5ee053ee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports